const level = [
  [ 0,  0, 99, 99, 99,  0,  0,  0,  0,  0],
  [ 0,  0, 99, 64, 99,  0,  0,  0,  0,  0],
  [ 0,  0, 99,  0, 99, 99, 99, 99,  0,  0],
  [99, 99, 99,  9,  0, 10, 77, 99,  0,  0],
  [99, 51,  0,  8, 52, 99, 99, 99,  0,  0],
  [99, 99, 99, 99,  7, 99,  0,  0,  0,  0],
  [ 0,  0,  0, 99, 38, 99,  0,  0,  0,  0],
  [ 0,  0,  0, 99, 99, 99,  0,  0,  0,  0],

]

export default level